import { FC } from 'react';
import { CatalogDestinationContent } from './catalogDestinationContent';

export const CatalogDestination: FC = () => {
  return <CatalogDestinationContent />;
};
